import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Navbar } from '../components/layout/Navbar'
import { AccountLayout } from '../components/layout/AccountLayout'
import { Stepper } from '../components/ui/Stepper'
import { Checkbox } from '../components/ui/Checkbox'
import { Button } from '../components/ui/Button'
import { Modal } from '../components/ui/Modal'
import { Input } from '../components/ui/Input'
import { useAuth } from '../components/auth/AuthContext'
import verificationCodeService, {
  VerificationCodeType,
} from '../services/verificationCodeService'
import { authService } from '../services/authService'
import toast from 'react-hot-toast'
import apiClient from '../services/api'
import companyService from '../services/companyService'
import ContinueLaterModal from '../components/onboarding/ContinueLaterModal'

export const CreditBureauConsultationPage = () => {
  const navigate = useNavigate()
  const { user, buroFailedCounter, updateBuroFailedCounter } = useAuth()
  const [acceptedTerms, setAcceptedTerms] = useState(false)
  const [showNIPModal, setShowNIPModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showLoadingModal, setShowLoadingModal] = useState(false)
  const [nipCode, setNipCode] = useState('')
  const [codeSent, setCodeSent] = useState(false)
  const [sendingCode, setSendingCode] = useState(false)
  const [verifyingCode, setVerifyingCode] = useState(false)
  const [email, setEmail] = useState('')

  const stepperSteps = [
    { id: '1', title: '', description: '', status: 'completed' as const },
    { id: '2', title: '', description: '', status: 'current' as const },
    { id: '3', title: '', description: '', status: 'pending' as const },
    { id: '4', title: '', description: '', status: 'pending' as const },
    { id: '5', title: '', description: '', status: 'pending' as const },
    { id: '6', title: '', description: '', status: 'pending' as const },
  ]

  useEffect(() => {
    const loadExistingData = async () => {
      try {
        // First, get RFC and email from localStorage

        // Get existing companies for the user
        const existingCompanies = await companyService.getCompanies()

        if (existingCompanies.length > 0) {
          const company = existingCompanies[0]

          setEmail(company.email || '')
        }
      } catch (error) {
        console.error('Error loading existing data:', error)
      }
    }

    loadExistingData()
  }, [])

  const handleContinue = async () => {
    if (!acceptedTerms) {
      toast.error('Debes aceptar los términos y condiciones para continuar')
      return
    }

    if (!user?.email) {
      toast.error('No se pudo obtener el email del usuario')
      return
    }

    setShowNIPModal(true)

    // Send verification code when modal opens
    await sendVerificationCode()
  }

  const handleNIPConfirm = async () => {
    if (!nipCode.trim()) {
      toast.error('Por favor ingresa el código de verificación')
      return
    }

    if (!user?.email) {
      toast.error('No se pudo obtener el email del usuario')
      return
    }

    setVerifyingCode(true)

    try {
      const response = await verificationCodeService.verifyAndAuthorizePM({
        code: nipCode.trim(),
        email: user.email,
        type: VerificationCodeType.COMPANY_VERIFICATION,
        reportType: '007', // Default report type
      })
      console.log('response Codigo', response)

      if (response.success) {
        setShowNIPModal(false)
        setShowLoadingModal(true)
        updateBuroFailedCounter(0)

        // Show processing for a moment before success
        setTimeout(() => {
          setShowLoadingModal(false)
          setShowSuccessModal(true)

          // Show success message with report details
          if (response.reportId) {
            toast.success(
              `Reporte generado exitosamente. ID: ${response.reportId}`
            )
          }
        }, 3000)
      } else {
        if (
          response.message === 'Máximo número de intentos alcanzado' ||
          response.message === 'Código de verificación no encontrado' ||
          response.message === 'Código incorrecto' ||
          response.data?.message === 'El código ha expirado' ||
          response.data?.message === 'Máximo número de intentos alcanzado' ||
          response.data?.message === 'Código de verificación no encontrado' ||
          response.data?.message === 'Código incorrecto'
        ) {
          // updateBuroFailedCounter(buroFailedCounter + 1)
          toast.error(
            response.message ||
              response.data?.message ||
              'Código de verificación inválido'
          )
          return
        } else {
          updateBuroFailedCounter(buroFailedCounter + 1)
          // toast.error(response.message || 'Código de verificación inválido')
          // return
        }
        console.log(buroFailedCounter + ' 2do log')

        if (buroFailedCounter + 1 >= 1) {
          setShowNIPModal(false)
          setShowLoadingModal(true)

          // Show processing for a moment before success
          setTimeout(() => {
            setShowLoadingModal(false)
            setShowSuccessModal(true)
          }, 3000)
        }
      }
    } catch (error: any) {
      console.error('Error verifying code:', error)
      toast.error(
        error.response?.data?.message ||
          'Error al procesar la solicitud de Buró de Crédito'
      )
    } finally {
      setVerifyingCode(false)
    }
  }

  const handleSuccessConfirm = async () => {
    setShowSuccessModal(false)

    // Determinar la siguiente URL
    let nextUrl = '/onboarding/majority-shareholder-data'
    let estatus = 'Datos Accionista'

    if (buroFailedCounter === 1) {
      nextUrl = '/onboarding/company-data'
      estatus = 'Datos Básicos'
    }
    if (buroFailedCounter > 1) {
      updateBuroFailedCounter(0)
    }

    // Actualizar estatus a 'Datos Accionista'
    try {
      const prospectoQuoteId = localStorage.getItem('prospectoQuoteId')
      const token = localStorage.getItem('auth_token')
      if (prospectoQuoteId && token) {
        await apiClient.patch(
          `/cotizador/mis-cotizaciones-prospecto/${prospectoQuoteId}/estatus`,
          { estatus },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        console.log('✅ Estatus "Datos Accionista" actualizado exitosamente')
      } else {
        console.warn(
          '⚠️ prospectoQuoteId o token no encontrado en localStorage'
        )
      }
    } catch (estatusError) {
      console.error(
        '❌ Error actualizando estatus "Datos Accionista":',
        estatusError
      )
    }

    // Actualizar progressURL en credit-application después del éxito
    try {
      console.log(
        '📍 Updating progressURL after successful credit bureau consultation...'
      )
      const creditAppId = await authService.getCurrentCreditApplicationId()

      if (creditAppId) {
        await authService.updateCreditApplicationProgress(creditAppId, nextUrl)
        console.log('✅ ProgressURL updated successfully to:', nextUrl)
      } else {
        console.warn(
          '⚠️ No credit application ID found, skipping progressURL update'
        )
      }
    } catch (progressError) {
      console.error('❌ Error updating progressURL:', progressError)
      // No detener el flujo si falla la actualización del progreso
    }
    navigate(nextUrl)
  }

  const sendVerificationCode = async () => {
    if (!user?.email) {
      toast.error('No se pudo obtener el email del usuario')
      return
    }

    setSendingCode(true)

    try {
      const response = await verificationCodeService.createCode({
        type: VerificationCodeType.COMPANY_VERIFICATION,
        email: user.email,
        metadata: JSON.stringify({
          purpose: 'pm_credit_bureau_authorization',
          context: 'company_consultation',
        }),
      })

      if (response.success) {
        setCodeSent(true)
        toast.success('Código de verificación enviado a tu correo')
      } else {
        toast.error(response.message || 'Error al enviar el código')
      }
    } catch (error: any) {
      console.error('Error sending verification code:', error)
      toast.error(
        error.response?.data?.message ||
          'Error al enviar el código de verificación'
      )
    } finally {
      setSendingCode(false)
    }
  }

  const handleResendCode = async () => {
    if (!user?.email) {
      toast.error('No se pudo obtener el email del usuario')
      return
    }

    await sendVerificationCode()
  }

  const handleModalClose = () => {
    setShowNIPModal(false)
    setNipCode('')
    setCodeSent(false)
  }

  return (
    <>
      {/* Mobile Layout */}
      <div className="min-h-screen flex flex-col md:hidden">
        {/* Mobile Header */}
        <Navbar logoSize="large" />

        {/* Mobile Content */}
        <div className="flex-1 bg-olr-white p-6">
          {/* Stepper */}
          <div className="mb-8">
            <Stepper
              steps={stepperSteps}
              variant="mobile"
              className="justify-center"
            />
          </div>

          {/* Contenido principal */}
          <div className="text-center mb-6 sm:mb-8">
            <h1 className="text-lg sm:text-h3 text-olr-dark mb-3 sm:mb-4 font-semibold">
              Consulta de Buró de crédito - Empresa
            </h1>
            <div className="text-sm sm:text-paragraph-2 text-olr-body space-y-1 leading-relaxed">
              <p>Es necesario hacer la consulta de Buró de Crédito.</p>
              <p>Iniciaremos con la consulta de la empresa.</p>
            </div>
          </div>

          {/* Sección de autorización */}
          <div className="bg-gray-100 rounded-xl p-6 mb-8">
            <h2 className="text-paragraph-1 font-semibold text-olr-dark mb-4">
              Autorización para consultar historial crediticio
            </h2>

            <div className="space-y-4 text-paragraph-2 text-olr-body leading-relaxed">
              <p>
                Por este conducto autorizo expresamente a OLR LEASING, S.A.P.I.
                DE C.V., para que por conducto de sus funcionarios facultados
                lleve a cabo investigaciones sobre mi comportamiento crediticio
                o el de la empresa que represento en las Sociedades de
                Información Crediticia que estime conveniente.
              </p>

              <p>
                Asimismo, declaro que conozco la naturaleza y alcance de las
                sociedades de información crediticia y de la información
                contenida en los reportes de crédito y reporte de crédito
                especial, declaro que conozco la naturaleza y alcance de la
                información que se solicitará, del uso de OLR LEASING, S.A.P.I.
                DE C.V., hará de tal información y de que ésta podrá realizar
                consultas periódicas sobre mi historial o el de la empresa que
                represento, consintiendo que ésta autorización se encuentre
                vigente por un período de 3 años contados a partir de su
                expedición y en todo caso durante el tiempo que se mantenga la
                relación jurídica.
              </p>

              <p>
                En caso de que la solicitante sea una Persona Moral, declaro
                bajo protesta de decir verdad Ser Representante Legal de la
                empresa mencionada en ésta autorización, manifestando que a la
                fecha de firma de la presente autorización los poderes no me han
                sido revocados, limitados, ni modificados en forma alguna.
              </p>
            </div>
          </div>

          {/* Checkbox */}
          <div className="mb-8">
            <Checkbox
              checked={acceptedTerms}
              onChange={e => setAcceptedTerms(e.target.checked)}
              label={
                <span className="text-sm font-medium">
                  Acepto la consulta de Buró de Crédito y los{' '}
                  <a
                    href="https://oautos.com.mx/terminos-y-condiciones-a"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-olr-primary underline font-semibold"
                  >
                    Términos y Condiciones
                  </a>
                </span>
              }
            />
          </div>

          {/* Botones */}
          <div className="flex flex-col space-y-3 sm:space-y-4">
            <Button
              variant="primary"
              onClick={handleContinue}
              className="w-full"
              disabled={!acceptedTerms}
            >
              Continuar
            </Button>
            <ContinueLaterModal />
          </div>
        </div>
      </div>

      {/* Desktop Layout: mismo shell de cuenta que el resto de onboarding. */}
      <div className="hidden md:block">
        <AccountLayout showSidebar={false}>
          <div className="max-w-4xl w-full px-16 py-8">
            {/* Stepper */}
            <div className="mb-6">
              <Stepper
                steps={stepperSteps}
                variant="desktop"
                orientation="horizontal"
                className="justify-center"
              />
            </div>

            {/* Contenido principal */}
            <div className="text-center mb-5">
              <h1 className="text-h3 text-olr-dark mb-4">
                Consulta de Buró de crédito - Empresa
              </h1>
              <div className="text-paragraph-1 text-olr-body">
                <p>
                  Es necesario hacer la consulta de Buró de Crédito. Iniciaremos
                  con la consulta de la empresa.
                </p>
              </div>
            </div>

            {/* Sección de autorización */}
            <div className="bg-gray-100 rounded-xl p-6 mb-4 max-w-4xl mx-auto">
              <h2 className="text-h4 text-olr-dark mb-4">
                Autorización para consultar historial crediticio
              </h2>

              <div className="space-y-4 text-paragraph-2 text-olr-body leading-relaxed">
                <p>
                  Por este conducto autorizo expresamente a OLR LEASING,
                  S.A.P.I. DE C.V., para que por conducto de sus funcionarios
                  facultados lleve a cabo investigaciones sobre mi
                  comportamiento crediticio o el de la empresa que represento en
                  las Sociedades de Información Crediticia que estime
                  conveniente.
                </p>

                <p>
                  Asimismo, declaro que conozco la naturaleza y alcance de las
                  sociedades de información crediticia y de la información
                  contenida en los reportes de crédito y reporte de crédito
                  especial, declaro que conozco la naturaleza y alcance de la
                  información que se solicitará, del uso de OLR LEASING,
                  S.A.P.I. DE C.V., hará de tal información y de que ésta podrá
                  realizar consultas periódicas sobre mi historial o el de la
                  empresa que represento, consintiendo que ésta autorización se
                  encuentre vigente por un período de 3 años contados a partir
                  de su expedición y en todo caso durante el tiempo que se
                  mantenga la relación juirídica.
                </p>

                <p>
                  En caso de que la solicitante sea una Persona Moral, declaro
                  bajo protesta de decir verdad Ser Representante Legal de la
                  empresa mencionada en ésta autorización, manifestando que a la
                  fecha de firma de la presente autorización los poderes no me
                  han sido revocados, limitados, ni modificados en forma alguna.
                </p>
              </div>
            </div>

            {/* Checkbox */}
            <div className="mb-4 max-w-4xl mx-auto">
              <Checkbox
                checked={acceptedTerms}
                onChange={e => setAcceptedTerms(e.target.checked)}
                label={
                  <span>
                    Acepto la consulta de Buró de Crédito y los{' '}
                    <a
                      href="https://oautos.com.mx/terminos-y-condiciones-a"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-olr-primary underline"
                    >
                      Términos y Condiciones
                    </a>
                  </span>
                }
              />
            </div>

            {/* Botones */}
            <div className="flex justify-center gap-4">
              <ContinueLaterModal />
              <Button
                variant="primary"
                onClick={handleContinue}
                disabled={!acceptedTerms}
                className="px-12 py-3 min-w-[230px]"
              >
                Continuar
              </Button>
            </div>
          </div>
        </AccountLayout>
      </div>

      {/* Modal de confirmación de NIP */}
      <Modal
        isOpen={showNIPModal}
        onClose={handleModalClose}
        size="sm"
        closeOnOverlay={false}
      >
        <div className="p-8 text-center">
          <h2 className="text-xl font-bold text-gray-900 mb-4">
            Confirmación de NIP
          </h2>

          {sendingCode ? (
            <div className="flex flex-col items-center justify-center mb-6">
              <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-3"></div>
              <p className="text-gray-600">
                Enviando código de verificación...
              </p>
            </div>
          ) : codeSent ? (
            <div className="mb-6">
              <p className="text-gray-600 mb-4">
                Hemos enviado un código NIP a su correo electrónico:{' '}
                <strong>{email}</strong>
              </p>
              <p className="text-sm text-gray-500 mb-4">
                Por favor, verifique sus mensajes e ingrese el código para
                continuar
              </p>

              <div className="mb-4">
                <Input
                  placeholder="Ingresa el código (ej: 123456)"
                  value={nipCode}
                  onChange={e => {
                    const value = e.target.value.replace(/\D/g, '') // Only allow digits
                    if (value.length <= 6) {
                      setNipCode(value)
                    }
                  }}
                  className="text-center text-lg font-medium"
                  maxLength={6}
                  disabled={verifyingCode}
                />
              </div>

              <button
                onClick={handleResendCode}
                className="text-sm text-blue-600 hover:text-blue-800 underline"
                disabled={sendingCode}
              >
                ¿No recibiste el código? Reenviar
              </button>
            </div>
          ) : (
            <div className="mb-6">
              <p className="text-red-600 mb-4">
                Error al enviar el código de verificación. Por favor, inténtalo
                de nuevo.
              </p>
              <Button
                variant="secondary"
                onClick={sendVerificationCode}
                className="w-full mb-4"
              >
                Reintentar envío
              </Button>
            </div>
          )}

          <div className="space-y-3">
            <Button
              variant="primary"
              onClick={handleNIPConfirm}
              className="w-full"
              disabled={!codeSent || !nipCode.trim() || verifyingCode}
            >
              {verifyingCode ? (
                <div className="flex items-center justify-center">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                  Verificando...
                </div>
              ) : (
                'Acepto realizar consulta'
              )}
            </Button>
            <Button
              variant="secondary"
              onClick={handleModalClose}
              className="w-full"
              disabled={verifyingCode}
            >
              Volver
            </Button>
          </div>
        </div>
      </Modal>

      {/* Modal de éxito */}
      <Modal isOpen={showSuccessModal} onClose={handleSuccessConfirm} size="sm">
        <div className="p-8 text-center">
          <div
            className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${
              buroFailedCounter >= 1 ? 'bg-yellow-500' : 'bg-[#68C72C]'
            }`}
          >
            {buroFailedCounter >= 1 ? (
              // Ícono de advertencia/alerta
              <svg
                className="w-8 h-8 text-white"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              // Ícono de éxito (check)
              <svg
                className="w-8 h-8 text-white"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>

          <h2 className="text-xl font-bold text-gray-900 mb-4">
            {buroFailedCounter === 1
              ? 'No fue posible completar la consulta de crédito, por favor de validar que su información sea correcta.'
              : buroFailedCounter > 1
                ? 'La consulta de crédito no pudo ser completada después de varios intentos.'
                : 'La consulta de reporte de crédito se ha completado con éxito'}
          </h2>

          <Button
            variant="primary"
            onClick={handleSuccessConfirm}
            className="w-full"
          >
            Continuar
          </Button>
        </div>
      </Modal>

      {/* Modal de loading */}
      <Modal
        isOpen={showLoadingModal}
        onClose={() => {}}
        size="sm"
        closeOnOverlay={false}
      >
        <div className="p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          </div>

          <h2 className="text-xl font-bold text-gray-900 mb-4">
            Consulta en proceso
          </h2>

          <div className="text-gray-600 space-y-2">
            <p>Gracias por autorizar la consulta a Buró.</p>
            <p>Por favor, espera un momento mientras terminamos la revisión.</p>
            <p>En unos momentos podrás continuar con el proceso</p>
          </div>
        </div>
      </Modal>
    </>
  )
}
